import {getRefTagAndOrigin, handleTracking} from '@jobseeker/common-core/utils';
import {Maven} from '@jobseeker/lotus/assets/images';
import {Avatar} from '@jobseeker/lotus/components';
import {Box, Grid, Link, Typography} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {useEffect} from 'react';

type DiversityProps = {
  data: {
    diversityUrl: string;
    image: string;
    about: string;
    name: string;
    designation: string;
    jobId?: number;
    companyId?: number;
  };
};

const Diversity = (props: DiversityProps) => {
  const {
    data: {diversityUrl, image, name, about, designation, jobId, companyId},
  } = props;

  const {origin, refText} = getRefTagAndOrigin();

  useEffect(() => {
    handleTracking('dvViewTestimonial', {
      event_category: 'Diversity',
      Source: 'JobDescription',
      CompanyId: companyId,
      UserId: sessionStorage.getItem('userId') || '',
      Jobid: jobId,
      Device: sessionStorage.getItem('device') || 'desktop',
      Ref: refText,
      Origin: origin,
    });
  }, [companyId, jobId, origin, refText]);

  return (
    <Box border="1px solid rgb(226, 226, 226)" mt={3} borderRadius="8px" mb={5}>
      <Box bgcolor="rgb(246, 246, 246)" pt={1} px={2.5}>
        <Image src={Maven} alt="maven-logo" width={113} height={33} />
      </Box>
      <Grid container className="testimonial" p={2.5}>
        <Grid
          item
          xs={12}
          md={9}
          display="flex"
          borderRight={{xxs: 'none', md: '2px solid rgb(240, 240, 240)'}}
        >
          <Typography
            variant="body1"
            fontSize={15}
            fontWeight={400}
            sx={{opacity: 0.7}}
            mr={{xxs: 0, md: 4}}
          >
            <Typography mr={5} component="span" width={47}>
              <Box
                sx={{
                  position: 'relative',
                  '&::before': {
                    content: '"\\201C"',
                    fontSize: 120,
                    position: 'absolute',
                    left: '-10px',
                    top: '-50px',
                    color: '#ccc',
                  },
                }}
              />
            </Typography>
            {about}
          </Typography>
        </Grid>
        <Grid
          item
          className="profile"
          md={3}
          xs={12}
          mt={{xxs: 2, md: 0}}
          textAlign="center"
        >
          <Avatar
            imgUrl={image}
            sx={{
              borderRadius: '50%',
              width: '50px',
              height: '50px',
            }}
          />
          <Typography fontSize={14} fontWeight={700}>
            {name}
          </Typography>
          <Typography mb={1} fontSize={14} fontWeight={300} lineHeight={'16px'}>
            {designation}
          </Typography>
          <Link
            href={`${diversityUrl}?ref=jdtestimonial`}
            onClick={() => {
              handleTracking('dvClickTestimonial', {
                event_category: 'Diversity',
                Source: 'JobDescription',
                CompanyId: companyId,
                UserId: sessionStorage.getItem('userId') || '',
                Jobid: jobId,
                Device: sessionStorage.getItem('device') || 'desktop',
                Ref: refText,
                Origin: origin,
              });
            }}
          >
            See diversity initiatives
          </Link>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Diversity;
